module.exports = __webpack_public_path__ + "static/media/cloud-meatball.2c1c5e77.svg";